import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container mx-4 mt-6 mb-30 flex flex-col gap-4 lg:mt-15 lg:flex-row lg:gap-16 xl:gap-22.5',
    contentContainer: 'min-w-0 flex-1',
    menu: 'relative hidden shrink-0 lg:block lg:max-w-[300px] xl:max-w-[400px]',
    menuInner:
      'max-md:[--inactive:1] lg:[--offset-top:calc(var(--head-fixed-height)+24px)]',
    back: 'lg:hidden',
    backButton: 'px-0',
    backText: 'ml-2',
    backIcon: 'scale-x-[-1]',
    title: 'text-3xl',
    subtitle: 'text-m leading-[170%]',
    description: 'mt-5',
    content: 'prose-headings:scroll-mt-[calc(var(--head-fixed-height)+24px)]',
    tableOfContents: 'container-outset my-10 lg:mx-0 lg:my-12',
    banner: ''
  },
  variants: {
    openMenu: {
      true: {
        back: 'hidden',
        contentContainer: 'hidden lg:block',
        menu: 'block',
        banner: 'block'
      }
    },
    hideMobileBanner: {
      true: {
        banner: 'hidden lg:block'
      }
    }
  }
});
